export const phoneNumberRegularExpression = /^[5-9]{1}\d{9}$/;

export const emailIdRegularExpression =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const otpRegularExpression = /^[0-9]{6}$/;

export const pincodeRegularExpression = /^\d+$/;

export const zipCodeRegularExpression = /^\d+$/;

export const onlyDigitsRegularExpression = /^[0-9]+$/;

export const indianPincodeRegularExpression = /^\d{6}$/;

export const ifscCodeRegularExpression = /^[A-Z]{4}0[A-Z0-9]{6}$/;

export const onlyAlphabetsRegularExpression = /^[a-zA-Z ]+$/;

export const onlyAlphabetsAndNumbersRegularExpression = /^[a-zA-Z0-9]*$/;

export const panCardRegularExpression = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
export const fileExtensionRegularExpression = /[^.]+$/;

export const bankAccountNumberRegularExpression = /^\d{9,18}$/;
export const digitsPattern = '[0-9]*';
export const gstNumberRegularExpression =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const EMOJI_REGEX_PATTERN =
  /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

export const inviteCodeRegularExpression = /^[A-Z0-9]{4,}$/;
export const IfscCodeRegularExpression = /^[A-Z0-9]{11}$/;
export const yearRegularExpression = /^[0-9]{4}$/;
export const numberRegularExpression = /^[0-9]*$/;
export const couponCodeRegularExpression = /^[a-zA-Z0-9_]*$/;

export const PHONE_NUMBER_REGEX_TYPE = 'PHONE_NUMBER';
export const INVITE_CODE_REGEX_TYPE = 'INVITE_CODE';
export const PINCODE_REGEX_TYPE = 'PINCODE';
export const EMAIL_REGEX_TYPE = 'EMAIL';
export const YEAR_REGEX_TYPE = 'YEAR';
export const PAN_CARD_REGEX_TYPE = 'PAN_CARD';
export const NUMBER_REGEX_TYPE = 'NUMBER';
